import React from "react";

const LoadingOverlay: React.FC = () => {
  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="spinner--wv-star">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
